import { render, staticRenderFns } from "./DiscountEditPage.vue?vue&type=template&id=005350f5"
import script from "./DiscountEditPage.vue?vue&type=script&lang=ts"
export * from "./DiscountEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports